export function isTrialLink(url) {
  if (!url) return false

  return url.includes('code=AHA_21169')
}

export function scheduleShowEnjoyTrialPopup() {
  sessionStorage.setItem('enjoy_trial_popup', 'true')
}

export function canShowEnjoyTrialPopup() {
  return sessionStorage.getItem('enjoy_trial_popup') === 'true'
}

export function scheduleShowTrialNotAvailablePopup() {
  sessionStorage.setItem('trial_not_available_popup', 'true')
}

export function canShowTrialNotAvailablePopup() {
  return sessionStorage.getItem('trial_not_available_popup') === 'true'
}

export function clearPopupSessionData() {
  sessionStorage.removeItem('enjoy_trial_popup')
  sessionStorage.removeItem('trial_not_available_popup')
}

export function thisUserHasSubscribedTrialPlan(user) {
  if (!user) return false
  return user.plan === 'free' && user.personalInformation &&
    user.personalInformation.hasSubscribedTrialPlan
}

export function thisUserHasUpgradedPlan(user) {
  if (!user) return false
  return user.plan !== 'free' && user.plan !== 'trial-plus-monthly'
}
